// extracted by mini-css-extract-plugin
export default {"button":"Buttons_button__be3AZ"};